import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';


export interface ComponentCanDeactivate {
  canDeactivate(): boolean | Observable<boolean>;
}

export const CanDeactivateState = {
  defendAgainstBrowserBackButton: false,
};

@Injectable({providedIn: 'root'})
export class CanDeactivateGuard  {

  constructor(
    readonly matDialog: MatDialog,
  ) {
  }

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    const canDeactivate = component.canDeactivate();
    if (typeof canDeactivate === 'boolean') {
      if (!canDeactivate && CanDeactivateState.defendAgainstBrowserBackButton) {
        history.pushState(null, '', '');
      }
      return canDeactivate;
    }
    return canDeactivate.pipe(
      tap((confirmed: boolean) => {
        if (!confirmed && CanDeactivateState.defendAgainstBrowserBackButton) {
          history.pushState(null, '', '');
        }
      })
    );
  }
}
